import { render } from "./StatCard.vue?vue&type=template&id=554bb180&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=554bb180&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554bb180"]])

export default __exports__